import Users from './Users.vue'
import UserList from './UserList.vue'
import CreateUser from './CreateUser.vue'
import EditUser from './EditUser.vue'

export default {
  path: "users",
  component: Users,
  children: [
    { path: "", component: UserList },
    { path: "create", component: CreateUser },
    { path: ":id", component: EditUser }
  ],
  meta: { requiresAdminPermissions: true }
}
